export default {
  type: 'fyUserMetricsManual',
  name: 'Manual User Project',
  permissions: {
    view: { app: 'metrics_dash', role: 'metrics_fy_users' },
    insert: { app: 'metrics_dash', role: 'metrics_fy_users' },
    update: { app: 'metrics_dash', role: 'metrics_fy_users' },
    delete: { app: 'metrics_dash', role: 'metrics_fy_users' }
  },
  search: {
    search: 'allFyUserMetricsManuals',
    orderBy: {
      type: 'FyUserMetricsManualsOrderBy',
      default: 'PROJECT_TITLE_ASC'
    },
    fields: [
      {
        name: 'fy',
        label: 'Fiscal Year',
        type: 'number',
        fieldType: 'Int',
        min: 2016,
        default: '$store.state.currentFiscalYear'
      },
      {
        name: 'projectTitle',
        order: 'PROJECT_TITLE'
      },
      {
        name: 'email'
      }
    ]
  },
  save: {
    fields: [
      {
        field: 'fy',
        type: 'Int',
        required: true
      },
      {
        field: 'projectTitle',
        required: true
      },
      {
        field: 'email',
        required: true
      },
      {
        field: 'projectTypeCode',
        required: true
      },
      {
        field: 'fundingSource',
        required: true
      },
      {
        field: 'nameFirst',
        required: true
      },
      {
        field: 'nameLast',
        required: true
      },
      {
        field: 'source',
        required: true
      },
      {
        field: 'employmentTypeCode',
        required: true
      },
      {
        field: 'affiliation',
        required: true
      },
      {
        field: 'smallBusiness',
        type: 'checkbox',
        required: true,
        default: false
      },
      'address',
      'city',
      'state',
      'zipCode',
      'countryCode',
      'orcid'
    ],
    key: ['fy', 'projectTitle', 'email'],
    input: 'fyUserMetricsManual',
    create: 'createFyUserMetricsManual',
    delete: 'deleteFyUserMetricsManual',
    update: 'updateFyUserMetricsManual'
  },
  load: {
    nodeId: 'fyUserMetricsManual',
    key: 'fyUserMetricsManualByFyAndProjectTitleAndEmail'
  },
  form: {
    print: false,
    schema: [
      [
        {
          name: 'fy',
          label: 'Fiscal Year',
          type: 'number',
          required: true,
          width: 3
        },
        {
          name: 'projectTitle',
          required: true,
          width: 9
        }
      ],
      [
        {
          name: 'projectTypeCode',
          label: 'Project Type',
          required: true,
          width: 4,
          type: 'select',
          options: {
            lookup: 'allProjectTypes',
            value: 'projectTypeCode',
            text: 'projectTypeDesc'
          }
        },
        {
          name: 'fundingSource',
          required: true,
          width: 6
        },
        {
          name: 'source',
          required: true,
          type: 'select',
          options: ['Onsite', 'Remote', 'Data'],
          default: 'Data',
          width: 2
        }
      ],
      [
        {
          name: 'nameFirst',
          label: 'First Name',
          required: true,
          width: 4
        },
        {
          name: 'nameLast',
          label: 'Last Name',
          required: true,
          width: 4
        },
        {
          name: 'email',
          required: true,
          width: 4
        }
      ],
      [
        {
          name: 'affiliation',
          type: 'link',
          required: true,
          width: 9,
          search: {
            field: 'instName',
            lookup: 'allInstitutions',
            additionalFields: [
              {
                name: 'address1',
                type: 'hidden',
                copyTo: 'address'
              },
              {
                name: 'city',
                type: 'hidden',
                copyTo: 'city'
              },
              {
                name: 'state',
                type: 'hidden',
                copyTo: 'state'
              },
              {
                name: 'zipCode',
                type: 'hidden',
                copyTo: 'zipCode'
              },
              {
                name: 'countryCode',
                type: 'hidden',
                copyTo: 'countryCode'
              },
              {
                name: 'smallBusiness',
                type: 'hidden',
                copyTo: 'smallBusiness'
              }
            ]
          }
        },
        {
          name: 'smallBusiness',
          type: 'checkbox',
          width: 3
        }
      ],
      [
        {
          name: 'address',
          width: 12
        }
      ],
      [
        {
          name: 'city',
          width: 4
        },
        {
          name: 'state',
          width: 4
        },
        {
          name: 'zipCode',
          width: 4
        }
      ],
      [
        {
          name: 'countryCode',
          label: 'Country',
          type: 'select',
          options: {
            allowNull: true,
            lookup: 'allCountries',
            value: 'countryCode',
            text: 'countryName',
            params: [
              {
                field: 'orderBy',
                passArray: true,
                type: 'CountriesOrderBy',
                default: 'COUNTRY_NAME_ASC'
              }
            ]
          },
          width: 12
        }
      ],
      [
        {
          name: 'employmentTypeCode',
          label: 'Employment Type',
          type: 'select',
          required: true,
          options: {
            lookup: 'allEmploymentTypes',
            value: 'employmentTypeCode',
            text: 'employmentTypeDesc'
          },
          width: 6
        },
        {
          name: 'orcid',
          label: 'ORCID',
          width: 6
        }
      ]
    ]
  }
}
